/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { HexListFragmentDoc } from "../hex-list/HexList.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetHexesForQuickNavQueryVariables = Types.Exact<{
  onlyStarred: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  onlyViewed: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  order: Types.InputMaybe<Types.HexOrder>;
  first: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type GetHexesForQuickNavQuery = {
  readonly __typename: "Query";
  readonly hexes: {
    readonly __typename: "HexesConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasPreviousPage: boolean;
      readonly hasNextPage: boolean;
      readonly startCursor: c.Cursor | null;
      readonly endCursor: c.Cursor | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "HexesEdge";
      readonly node: {
        readonly __typename: "Hex";
        readonly id: c.HexId;
        readonly userUpdatedDate: c.DateTimeString;
        readonly trashDate: c.DateTimeString | null;
        readonly canShare: boolean;
        readonly maxGrantableRole: Types.ProjectRole | null;
        readonly canViewLogic: boolean;
        readonly effectiveRole: Types.ProjectRole | null;
        readonly starredByViewer: boolean;
        readonly hexType: Types.HexType;
        readonly projectLanguage: Types.ProjectLanguage;
        readonly canDelete: boolean;
        readonly canEdit: boolean;
        readonly canEditorsShare: boolean;
        readonly archivedDate: c.DateTimeString | null;
        readonly publicRoleV2: Types.ProjectRole | null;
        readonly organizationRoleV2: Types.ProjectRole | null;
        readonly grantSummary: c.ProjectGrantSummary;
        readonly onlyGrantedToCurrentUser: boolean;
        readonly totalViewCount: number;
        readonly currentDraft: {
          readonly __typename: "HexVersion";
          readonly id: c.HexVersionId;
          readonly title: string;
          readonly createdDate: c.DateTimeString;
          readonly description: string | null;
          readonly logicSessionId: c.AppSessionId;
          readonly canEdit: boolean;
          readonly status: {
            readonly __typename: "Status";
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
          readonly categories: ReadonlyArray<{
            readonly __typename: "Category";
            readonly id: c.CategoryId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
          }>;
          readonly denialReason:
            | {
                readonly __typename: "AssetAccess";
                readonly hasAccessToSharedDataConnections: boolean;
                readonly hasAccessToSharedFiles: boolean;
                readonly hasAccessToSharedPackages: boolean;
                readonly hasAccessToSharedSecrets: boolean;
                readonly hasAccessToSharedSyncRepositories: boolean;
              }
            | { readonly __typename: "MissingProjectRole" }
            | null;
        };
        readonly creator: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly name: string | null;
          readonly email: string;
        };
        readonly lastPublishedVersion: {
          readonly __typename: "HexVersion";
          readonly id: c.HexVersionId;
          readonly title: string;
          readonly status: {
            readonly __typename: "Status";
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
          readonly categories: ReadonlyArray<{
            readonly __typename: "Category";
            readonly id: c.CategoryId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
          }>;
        } | null;
        readonly org: {
          readonly __typename: "Org";
          readonly id: c.OrgId;
          readonly displayName: string;
          readonly allowPublicSharing: boolean;
        };
        readonly projectAnalytics: {
          readonly __typename: "HexAnalytics";
          readonly id: c.HexAnalyticsId;
          readonly totalViewsLast7Days: number;
          readonly totalViewsLast14Days: number;
          readonly totalViewsLast30Days: number;
        };
      };
    }>;
  };
};

export const GetHexesForQuickNavDocument = /*#__PURE__*/ gql`
  query GetHexesForQuickNav(
    $onlyStarred: Boolean
    $onlyViewed: Boolean
    $order: HexOrder
    $first: Int
  ) {
    hexes(
      ownershipLevel: ALL
      onlyPublished: false
      onlyStarred: $onlyStarred
      onlyViewed: $onlyViewed
      order: $order
      trashed: false
      first: $first
      hexTypes: [PROJECT, COMPONENT]
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          ...HexListFragment
        }
      }
    }
  }
  ${HexListFragmentDoc}
`;

/**
 * __useGetHexesForQuickNavQuery__
 *
 * To run a query within a React component, call `useGetHexesForQuickNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHexesForQuickNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHexesForQuickNavQuery({
 *   variables: {
 *      onlyStarred: // value for 'onlyStarred'
 *      onlyViewed: // value for 'onlyViewed'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetHexesForQuickNavQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetHexesForQuickNavQuery,
    GetHexesForQuickNavQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHexesForQuickNavQuery,
    GetHexesForQuickNavQueryVariables
  >(GetHexesForQuickNavDocument, options);
}
export function useGetHexesForQuickNavLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHexesForQuickNavQuery,
    GetHexesForQuickNavQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHexesForQuickNavQuery,
    GetHexesForQuickNavQueryVariables
  >(GetHexesForQuickNavDocument, options);
}
export function useGetHexesForQuickNavSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHexesForQuickNavQuery,
    GetHexesForQuickNavQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHexesForQuickNavQuery,
    GetHexesForQuickNavQueryVariables
  >(GetHexesForQuickNavDocument, options);
}
export type GetHexesForQuickNavQueryHookResult = ReturnType<
  typeof useGetHexesForQuickNavQuery
>;
export type GetHexesForQuickNavLazyQueryHookResult = ReturnType<
  typeof useGetHexesForQuickNavLazyQuery
>;
export type GetHexesForQuickNavSuspenseQueryHookResult = ReturnType<
  typeof useGetHexesForQuickNavSuspenseQuery
>;
export type GetHexesForQuickNavQueryResult = Apollo.QueryResult<
  GetHexesForQuickNavQuery,
  GetHexesForQuickNavQueryVariables
>;
